<template>
	<div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Data</label>
		        <input
		        	type="date"
		        	class="form-control"
		        	v-model="dados.data"
		        	:id="name+'data'"
		        	@input="clearValidation('data')">
		        <div class="invalid-feedback" :id="name+'data-invalid-feedback'"></div>
		    </div>
        </div>
	</div>
</template>

<script>
	export default {
		props: ['dados', 'name', 'errors'],
		data(){
			return {
				elementos: Object.keys(this.dados)
			}
		},
		methods : {
			clearValidation(element){
				this.$bshValidation.clear(element, this.name);
			}
        },
        watch: {
            errors: function() {
                this.$bshValidation.valide(this.elementos, this.errors, this.name);
            },
        }
    }
</script>
